import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { func, bool, string, shape } from "prop-types";
import { actions as modalActions } from "reducers/modal";
import { compose } from "redux";
import { connect } from "react-redux";
import Button from "pages/_components/Button";
import Row from "react-bootstrap/lib/Row";
import Grid from "react-bootstrap/lib/Grid";
import Col from "react-bootstrap/lib/Col";
import MainContainer from "pages/_components/MainContainer";

const ModalButton = styled(Button)``;

const InfoModal = ({
    handlerAccept,
    modalSubtitle,
    body,
    preBody,
    postBody,
    cancelLabel,
    acceptLabel,
    noAcceptButton,
    noCancelButton,
    useScroll,
    isFetching,
    dispatch,
    onClick,
}) => {
    const [isAcceptButtonDisabled, setIsAcceptButtonDisabled] = useState(true);

    useEffect(() => {
        if (!useScroll) {
            setIsAcceptButtonDisabled(false);
        }
        // eslint-disable-next-line
    }, []);

    const checkScrollable = useCallback(
        (modalBody) => {
            if (modalBody !== null && isAcceptButtonDisabled) {
                if (modalBody.scrollHeight <= modalBody.clientHeight) {
                    setIsAcceptButtonDisabled(false);
                }
            }
        },
        // eslint-disable-next-line
        [],
    );

    const handleScroll = ({ target: { scrollTop, clientHeight, scrollHeight } }) => {
        const errorMarginPx = 2;
        if (isAcceptButtonDisabled && Math.trunc(scrollHeight - scrollTop) <= clientHeight + errorMarginPx) {
            setIsAcceptButtonDisabled(false);
        }
    };

    const handleClickButtonClose = () => {
        dispatch(modalActions.modalClose());
    };

    return (
        <Modal scrollable show onHide={handleClickButtonClose}>
            {/* <ModalHeader /> */}
            <MainContainer showLoader={isFetching} ref={checkScrollable} onScroll={handleScroll}>
                <div onClick={onClick} aria-hidden="true">
                    <Grid className="form-content">
                        <Row className="justify-content-center">
                            <Col xs={12} md={8} mdOffset={2}>
                                {typeof modalSubtitle !== "undefined" ? (
                                    modalSubtitle && (
                                        <div className="modal-subtitle">
                                            <h2 className="text-center">{modalSubtitle}</h2>
                                        </div>
                                    )
                                ) : (
                                    <></>
                                )}

                                {typeof preBody !== "undefined" ? preBody() : <></>}

                                {body()}

                                {typeof postBody !== "undefined" ? postBody() : <></>}
                                {!noCancelButton && (
                                    <ModalButton
                                        bsStyle="outline"
                                        label={cancelLabel}
                                        onClick={handleClickButtonClose}
                                        block
                                    />
                                )}
                                {!noAcceptButton && (
                                    <ModalButton bsStyle="outline" label={acceptLabel} onClick={handlerAccept} block />
                                )}
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </MainContainer>
        </Modal>
    );
};

InfoModal.propTypes = {
    dispatch: func.isRequired,
    handlerAccept: func.isRequired,
    body: func.isRequired,
    preBody: func,
    postBody: func,
    modalSubtitle: string,
    noAcceptButton: bool,
    noCancelButton: bool,
    cancelLabel: string,
    acceptLabel: string,
    useScroll: bool,
    isFetching: bool,
    onClick: shape({}),
};

InfoModal.defaultProps = {
    noAcceptButton: false,
    noCancelButton: false,
    useScroll: true,
    acceptLabel: "",
    cancelLabel: "",
    modalSubtitle: "",
    isFetching: false,
    preBody: undefined,
    postBody: undefined,
    onClick: () => {},
};

export default compose(connect())(InfoModal);
